import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "@/components/common/text-input";

export const PushSettingsReadonly: React.FC<{
  subscribed?: boolean;
  pushFrequency?: number; // 单位：天
  pushQuantity?: number;
  pushTime?: string;      // "HH:mm" 或 "-"
  showPushSettings?: boolean;
}> = ({ subscribed, pushFrequency, pushQuantity, pushTime, showPushSettings = true }) => {
  const { t } = useTranslation();

  const statusLabel = useMemo(() => {
    return subscribed ? t("agent_creation.subscription_settings.subscribed") : t("agent_creation.subscription_settings.unsubscribed");
  }, [subscribed, t]);

  const frequencyLabel = useMemo(() => {
    return pushFrequency != null ? `${pushFrequency} ${t("agent_creation.subscription_settings.day_unit")}` : "";
  }, [pushFrequency, t]);

  const amountLabel = useMemo(() => {
    return pushQuantity != null ? `${pushQuantity} ${t("agent_creation.subscription_settings.item_unit")}` : "";
  }, [pushQuantity, t]);

  const timeLabel = useMemo(() => {
    return pushTime ?? "";
  }, [pushTime]);

  return (
    <div className="flex flex-col">

      <div className="space-y-4">
        {subscribed && showPushSettings && (
          <div className="flex flex-col items-start gap-3">
            <div className="text-base font-medium text-[rgba(52,64,84,1)]">
              {t("agent_creation.subscription_settings.subscription_status")}
            </div>
            <button className="text-sm font-medium text-[rgba(117,66,247,1)] hover:underline cursor-default">
              {statusLabel}
            </button>
          </div>
        )}
        {subscribed && showPushSettings && (
          <>
            <div className="text-base font-medium text-[rgba(16,24,40,1)] mb-5">
              {t("agent_dashboard.user_detail.push_settings.title")}
            </div>
            <div className="flex flex-col items-start gap-3">
              <label className="inline-block text-sm text-[rgba(52,64,84,1)] font-medium">
                {t("agent_creation.subscription_settings.push_frequency")}
              </label>
              <TextInput disabled value={frequencyLabel} className="h-10 cursor-default text-sm text-[rgba(102,112,133,1)] font-medium bg-[rgba(249,250,251,1)] disabled:opacity-100" />
            </div>

            <div className="flex flex-col items-start gap-3">
              <label className="inline-block text-sm text-[rgba(52,64,84,1)] font-medium">
                {t("agent_creation.subscription_settings.push_amount")}
              </label>
              <TextInput disabled value={amountLabel} className="h-10 cursor-default text-sm text-[rgba(102,112,133,1)] font-medium bg-[rgba(249,250,251,1)] disabled:opacity-100" />
            </div>

            <div className="flex flex-col items-start gap-3">
              <label className="inline-block text-sm text-[rgba(52,64,84,1)] font-medium">
                {t("agent_creation.subscription_settings.push_time")}
              </label>
              <TextInput disabled value={timeLabel} className="h-10 cursor-default text-sm text-[rgba(102,112,133,1)] font-medium bg-[rgba(249,250,251,1)] disabled:opacity-100" />
            </div>
          </>
        )}
      </div>
    </div>
  );
};